import {
  Box_default
} from "./chunk-GDQZHQO7.js";
import {
  __objRest,
  __spreadValues
} from "./chunk-M54I523Y.js";

// packages/ui-lib/src/components/Divider.tsx
import React2, { forwardRef } from "react";

// packages/ui-lib/src/components/Divider.css.ts
var divider = "Divider__1eri9it0";

// packages/ui-lib/src/components/Divider.tsx
var Divider = forwardRef((_a, ref) => {
  var _b = _a, { p, orientation = "horizontal" } = _b, props = __objRest(_b, ["p", "orientation"]);
  return /* @__PURE__ */ React2.createElement(Box_default, __spreadValues({
    ref,
    py: p
  }, props), /* @__PURE__ */ React2.createElement(Box_default, {
    className: divider,
    "data-orientation": orientation
  }));
});
var Divider_default = Divider;

export {
  Divider_default
};
//# sourceMappingURL=chunk-EO3353TK.js.map
